export const LISTINGS = {
  grade: 'Your grade is based on Etsy best practices and listing performance.\n\n Listings with recent sales receive a higher grade.',
  thumbnail: '',
  title: 'Listing titles can be up to 140 characters long. However, Etsy recommends titles be short, clear and descriptive.',
  listing_id: 'The listing ID is a unique ID number assigned by Etsy to your listings.',
  notes: '',
  sku: 'SKU is a unique ID you add to your listings to help manage and keep track of your stock.',
  original_creation_timestamp: 'The date the listing was created.',
  last_modified_timestamp: 'The date the listing was last modified, sold or renewed.',
  ending_timestamp: 'The date the listing will expired.',
  state_timestamp: 'The date this listing was sold out.',
  seo_tips: 'eRank may have spotted a way to improve your listing.',
  age: 'How long the listing has been active.',
  visibility_score: 'The Visibility Score is a measurement of how well your listing’s daily views compare to listings from thousands of other Etsy shops.',
  views: 'Total views this listing has had since it was originally published on Etsy.',
  tag_count: 'The number of tags this listing has. Tags help your listings get found by buyers when searching. Etsy recommends using all 13 tags.',
  image_count: 'Etsy recommends using multiple images.',
  categories: 'Adding more specific categories will give you more opportunities to match with a search. When you add specific subcategories to your listing, your items are included in all the categories that subcategory is nested within.',
  quantity: 'The number of items currently in stock.',
  price: 'The sale price you have listed the item for.',
  inventory_value: 'The total value of the inventory you have in stock (calculated by multiplying the quantity available by the item price).',
  url: '',
  tags: 'Tags used by sellers in their Etsy listings.',
};

export const RANK_CHECKER = {
  rank: 'This is where the listing will appear for the average Etsy user (excluding personalization and localization).',
  page: 'This is the page number in which the listing will appear for the average Etsy user (excluding personalization and localization). Each page on Etsy has 48 results (excluding ads).',
  price: 'This is price of the item. Prices marked with * have been converted to USD.',
  views: 'The number of views the listing has had since it was created.',
  daily_views: 'The average views per day this listing has had since it was created.',
  favorites: 'The total number of favorites this listing has had since it was created.',
  created: 'The date the listing was created.',
  updated: 'The date the listing was updated.',
  vintage: 'Is the item classified as vintage.',
  handmade: 'Is the item classified as handmade.',
  image: "`This is the image that appears in Etsy search results. The first photo should clearly show the item that's for sale and be eye catching enough that buyers want to take a closer look.",
  title: 'Listing titles can be up to 140 characters long. However, Etsy recommends titles be short, clear and descriptive.',
  keyword: 'These are high-ranking search terms associated with the keyword you entered.',
};

export const SPOTTED_ON_ETSY = {
  listing_title: 'The title of the listing. Click any title to open our Listing Audit feature and perform a comprehensive audit of that listing',
  search_term: 'The keyword that was used to find the listing. Click any term to open our Keyword Tool feature and perform a detailed analysis of the top 100 listings found in Etsy search results for that keyword.',
  search_trends: 'This graph indicates how the popularity of the keywords changed over the past 15 months. From this you can get a sense of seasonality and whether a keyword is becoming more or less popular.',
  page: 'The page on which the listing was found in search. Without ads, each Etsy page contains 48 listings.',
  position: "This shows you where eRank found the listing on the keyword's search results page -- in other words, where the listing was ranking at that time.",
  rank: 'This graph shows how the rank of your listing changed over the past 14 days.',
  timestamp: 'The date and time the listing was found.',
  spotted_by: 'This tells you whether an Etsy visitor or eRank monitor spotted the listing in an Etsy search.',
};

export const COMPETITOR_SALES = {
  shop_name: (num) => `You can track the daily number of sales for up to ${num || 0} shops`,
  graph: 'Click to see a shop’s sales charted in a graph.',
  note: 'Add a custom note for each shop.',
  monthly_sales: 'The estimated number of monthly sales for each shop over the past 15 months.',
  total_sales: 'The number of sales each shop has had since it opened.',
  active_listings: 'The number of active listings each shop has.',
  shop_age: 'The length of time each shop has been live on Etsy.',
};

export const SPELL_CHECKER = {
  tag: 'Highlighted in red, this may be a misspelled word.',
  suggestions: 'These suggestions may help correct spelling.',
  listings_affected: 'This listing contains the word that may be misspelled. Click the Fix on Etsy button to correct the spelling in your Etsy shop. Return to eRank and click the Refresh Data button so eRank can update your data.',
};

export const TAG_REPORT = {
  tag: 'Tags used by sellers in their Etsy listings.',
  tag_occurences: 'How often this tag is used across your shop’s listings.',
  avg_searches: 'Average monthly searches on Etsy based on the past 12 months of Etsy data.',
  avg_clicks: 'Average monthly clicks that listings in searches for that keyword get on Etsy. Based on the past 12 months of Etsy data.',
  avg_ctr: 'The ratio of clicks to searches on Etsy, shown as a percentage. Based on the past 12 months of Etsy data.',
  etsy_competition: 'How much competition you can expect with this keyword on Etsy search results pages.',
  search_trend: 'This graph indicates how the popularity of the keywords changed over the past 15 months. From this you can get a sense of seasonality and whether a keyword is becoming more or less popular.',
  google_searches: 'Estimated number of searches performed on Google each month. Google search data is also useful for your website and can help you understand broader user-interest levels, keywords, and products.',
};
